const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Categories Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Categories', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  var fields = 'name,localized_names,location,department,category,company,level,parent,children,createdAt,show_external';
  var detailsFields = 'name,localized_names,location,department,category,company,level,parent,parent.parent,parent.children,parent.parent.children,children,children.children,createdAt,updatedAt,show_external';
  return $resource(appConfiguration.apiUrl + '/learn/v3/categories/:subresource/:subsubresource', null, {
    get: {params: {fields: detailsFields, subresource: ''}, method: 'GET', isArray: false},
    find: {params: {fields: fields, subresource: ''}, method: 'GET', isArray: true},
    findForAdmin: {params: {fields: fields, subresource: 'find-for-admin'}, method: 'GET', isArray: true},
    descendants: {params: {subresource: 'descendants'}, method: 'GET', isArray: true},
    managerFind: {params: {subresource: 'manager'}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    search: {params: {subresource: 'search'}, method: 'POST', isArray: true},
    fullTextSearch: {params: {subresource: 'full-text-search'}, method: 'GET', isArray: true},
    trimSelections: {params: {subresource: 'trim-selections'}, method: 'POST', isArray: true},
    multipleGet: {params: {subresource: 'multiple-get'}, method: 'POST', isArray: true},
    transfer: {params: {subresource: 'transfer'}, method: 'POST', isArray: false},
    toggleExternal: {params: {subresource: 'toggle-external'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
